<div class="col-12 col-md-12 devicesDashboard">
  <div class="card stats-card">
    <div class="widget-container device-stats">
      <div class="col-xs-3" style="height:100%;border-radius: 30px;
            background-image: radial-gradient(#1f71ff1a,white);">
        <div class="number color-blue">
          <div class="icon fa fa-globe visitors"></div>
          <span class="counter">{{totalDeviceCount}}</span>
        </div>
        <div class="text">
          <span>{{"Total Devices" | translate}}</span>
        </div>
      </div>
      <div class="col-xs-3" style="height:100%;border-radius: 30px;
            background-image: radial-gradient(#42cd001a,white);">
        <div class="number color-green">
          <div class="icon fa fa-check visitors"></div>
          <span class="counter">{{usableDeviceCount}}</span>
        </div>
        <div class="text">
          <span>{{"Usable Devices" | translate}}</span>
        </div>
      </div>
      <div class="col-xs-3" style="height:100%;background-image: radial-gradient(#ffc0cb4d,white);
            border-radius: 30px;">
        <div class="number color-pink">
          <div class="icon fa fa-users visitors"></div>
          <span class="counter">{{busyDeviceCount}}</span>
        </div>
        <div class="text">
          <span>{{"Busy Devices" | translate}}</span>
        </div>
      </div>
      <div class="col-xs-3" style="border-radius: 30px;
            height:100%;
            background-image: radial-gradient(#ffa1012d,white);">
        <div class="number color-orange">
          <div class="icon fa fa-user visitors"></div>
          <span data-type="using" class="counter">{{currentUserUsingDevice}}</span>
        </div>
        <div class="text">{{currentUser.email}}</div>
      </div>
    </div>
  </div>
</div>

<!-- //customize -->
<div class="widget-content padded">

  <div class="filtering-buttons">
    <datalist id="searchFields">
      <select name="searchFields">
        @for (column of columns; track column) {
        <option [value]="column.name + ': '" [innerText]="columnDefinitions[column.name].title | translate"></option>
        }
      </select>
    </datalist>
    @if (activeTab=='devices') {
    <input placeholder="Search" type="search" autosave="deviceFilterdevices" name="deviceFilterdevices"
      [(ngModel)]="searchDevices.deviceFilterdevices"
      (ngModelChange)="applyFilterDevices(searchDevices.deviceFilterdevices)" autocorrect="off" autocapitalize="off"
      spellcheck="false" multiple="multiple" focus-element="searchDevices.focusElement"
      text-focus-select="text-focus-select" accesskey="4" [attr.list]="'searchFields'"
      class="form-control input-sm device-search pull-right ng-pristine ng-valid ng-scope ng-empty ng-touched">
    }
    <div class="dropdown">
      @if (activeTab=='details') {
      <input placeholder="Search" [(ngModel)]=" searchDetails.deviceFilterdetails"
        (ngModelChange)="applyFilterDetails(searchDetails.deviceFilterdetails)"
        class="form-control input-sm device-search pull-right dropdown" type="search" autosave="deviceFilterdetails"
        name="deviceFilterdetails" autocorrect="off" autocapitalize="off" spellcheck="false" multiple="multiple"
        text-focus-select="text-focus-select" accesskey="4" [attr.list]="'searchFields'" />
      }
    </div>

    <span class="pull-right" style="position: relative; top: 4px; right: 5px;">
      <div class="btn-group">
        <!-- <button type="button" class="btn btn-xs" (click)="showMasterSlaveConfiguration()"
        style="border-radius: 0.3em; color: #167ffc; --bs-btn-hover-bg: #d3d4d5; z-index: 1; right: 5%; top: 10px;">
        <i class="fa fa-solid fa-gears"></i>
        {{"Configure Master Slave Devices" | translate}}
      </button> -->
        @if (activeTab=='details') {
        <button type="button" class="btn btn-xs btn-primary-outline" (click)="showColumns()"
          style="border-radius: 0.3em; color: #167ffc; --bs-btn-hover-bg: #d3d4d5;">
          <i class="fa fa-columns"></i>
          {{"Customize" | translate}}
        </button>
        }
        <ul class="dropdown-menu" [ngClass]="{'show': showCols}">
          @for (column of columns; track column) {
          <li>
            <div class="form-check">
              <!-- <input class="form-check-input" type="checkbox" [(ngModel)]="column.selected"
              (click)="update()">
              <label class="form-check-label">{{ column.name }}</label> -->
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" [(ngModel)]="column.selected" (click)="update()">
                {{ column.name | translate}}
              </label>
            </div>
          </li>
          }

          <li>
            <button class="btn btn-outline-danger btn-sm border-0" (click)="reset()">
              <i class="fa fa-trash-o"></i>
              <span>{{"Reset" | translate}}</span>
            </button>
          </li>

        </ul>
      </div>
    </span>
  </div>
  <div class="col-12 mt-2" style="height:100%;padding: 0vh 4vh 4vh 4vh; border-top: 1px solid #eeeeee;">
    <ul class="nav nav-tabs mb-1">
      <li class="nav-item">
        <a id="tabs" (click)="setActiveTab('devices')" class="nav-link active" data-bs-toggle="tab"
          data-bs-target="#device"><em class="fa fa-th-large"></em>{{" Devices" | translate}}</a>
      </li>
      <li class="nav-item">
        <a id="tabs" (click)="setActiveTab('details')" selected class="nav-link" data-bs-toggle="tab"
          data-bs-target="#detail"><em class="fa fa-list"></em>{{" Details" | translate}}</a>
      </li>
      <!-- commented for axis -->
      <li class="nav-item">
        <a id="tabs" (click)="setActiveTab('masterSlave')" selected class="nav-link" data-bs-toggle="tab"
          data-bs-target="#masterSlave"><em class="fa-brands fa-chromecast"></em>{{" Master Slave" | translate}}</a>
      </li>
    </ul>


    <div class="tab-content">
      <!-- style="overflow-x: auto; scrollbar-width: thin;" -->
      <div id="device" class="tab-pane fade show active" style="height: 100%;">
        <app-device-list-icons [tracker]="tracker" [columns]="defaultColumns" [sort]="defaultSort"
          [filter]="filterDevices"></app-device-list-icons>
      </div>
      <div id="detail" class="tab-pane fade">
        <app-device-list-details [tracker]="tracker" [columns]="columns" [sort]="defaultSort"
          [filter]="filterDetails"></app-device-list-details>
      </div>
      <div id="masterSlave" class="tab-pane fade">
        <!-- <h3 class="section-title">Select your Master Device</h3> -->
        <div class="heading-container">
          <h1 class="modern-heading">Select your Master Device</h1>
        </div>
        @if (devices?.length > 0) {
        <div class="device-list">
          @for (device of devices; track device) {
          <div class="device-card" (click)="selectMasterDevice(device)">
            <li class="thumbnail" [ngStyle]="{'opacity': device.enhancedStateAction=='Use'?1:0.5}">
              <a>
                <div class="device-photo-small">
                  <img id="device-image" src="assets/x120/_default.jpg">
                </div>
                <div class="device-name state-available"
                  style="margin-top: 5px; color: unset;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  {{device.model || device.serial}}</div>
                <span id="device-state">{{device.enhancedStateAction}}</span>
              </a>
            </li>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
  <!-- your.component.html -->
</div>


<!-- Modal template for master-slave configuration -->
<ng-template #masterSlaveConfigTemplate let-modal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{"Configure Master-Slave Devices" | translate}}</h4>
    <button type="button" class="btn btn-xs btn-danger close pull-right" aria-label="Close" (click)="modalRef.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      <!-- Package Name -->
      <div class="row mb-4">
        <div class="col-12">
          <h5>{{"Package Name" | translate}}</h5>
          <div class="form-group">
            <input type="text" class="form-control" [(ngModel)]="packageName"
              placeholder="{{'Enter Package Name' | translate}}">
          </div>
        </div>
      </div>
      <!-- Master Device Selection -->
      <div class="row mb-4">
        <div class="col-12">
          <h5>{{"Master Device" | translate}}</h5>
          <div class="form-group">
            <select class="form-control" [(ngModel)]="selectedMaster">
              <option [ngValue]="null">{{"Select Master Device" | translate}}</option>
              @for (device of devices; track device) {
              <option [ngValue]="device">
                {{device.model}}({{device.serial}})
              </option>
              }
            </select>
          </div>
        </div>
      </div>

      <!-- Slave Devices Selection -->
      <div class="row">
        <div class="col-12">
          <h5>{{"Slave Devices" | translate}} (4 required)</h5>
          <div class="slave-devices">
            @for (i of [0,1,2,3]; track i; let idx = $index) {
            <div class="form-group mb-2">
              <label>{{"Slave" | translate}} {{idx + 1}}</label>
              <select class="form-control" [(ngModel)]="slaveDevices[idx]">
                <option [ngValue]="null">{{"Select Slave Device" | translate}} {{idx + 1}}</option>
                @for (device of getAvailableSlaveDevices(idx); track device) {
                <option [ngValue]="device">
                  {{device.model}}({{device.serial}})
                </option>
                }
              </select>
            </div>
            }
          </div>
        </div>
      </div>

      <!-- Validation Message -->
      @if (validationMessage) {
      <div class="row mt-3">
        <div class="col-12">
          <div class="alert alert-danger">
            {{validationMessage}}
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.close()">{{"Cancel" | translate}}</button>
    <button type="button" class="btn btn-primary" (click)="saveMasterSlaveConfiguration()"
      [disabled]="!isConfigurationValid()">
      {{"Save" | translate}}
    </button>
    <button type="button" class="btn btn-primary" (click)="saveMasterSlaveConfiguration();Launch()"
      [disabled]="!isConfigurationValid()">
      {{"Save & Launch" | translate}}
    </button>
  </div>
</ng-template>

<ng-template #alertTemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>